import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import {
  convertToLowestUnit,
  ExportAvailableInCSVForReports,
  exportFromula,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import { getDateRangeFromMonth } from "../../../../helpers/commonFunctions";

const BranchwiseItemUsedInventoriesCostReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingBranchDetails, setIsLoadingBranchDetails] = useState(false);
  const [isLoadingItemDetails, setIsLoadingItemDetails] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const searchSigRef = useRef("");
  const didAutoLoad = useRef(false);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const monthYear = params.get("month");

    if (monthYear) {
      const dateRange = getDateRangeFromMonth(monthYear);
      if (dateRange) {
        setDateFrom(dateRange.startDate);
        setDateTo(dateRange.endDate);
      }
    } else {
      const currentDay = new Date();
      setDateFrom(formatDate(currentDay));
      setDateTo(formatDate(currentDay));
    }
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
    }
  }, [dateFrom, dateTo]);

  useEffect(() => {
    if (dateFrom && dateTo) {
      const params = new URLSearchParams(window.location.search);
      const storeId = params.get("store_id");
      const monthYear = params.get("month");
      if (!storeId && !monthYear) return;
      if (didAutoLoad.current) return;
      didAutoLoad.current = true;
      const loadDataWithParams = async () => {
        const orders = await loadOrders();
        if (orders && storeId) {
          const selectedStore = orders.find(
            (store) => String(store._id) === String(storeId),
          );
          if (selectedStore) {
            setSelectedBranch(selectedStore);
            setSelectedRow(selectedStore);
            await loadBranchwiseUsedItemsDetails(selectedStore);
          }
        }
      };

      loadDataWithParams();
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      if (!dateFrom || !dateTo) return null;
      setIsLoadingOrders(true);
      let url = process.env.REACT_APP_BASEURL + "reports/branchwise_used_items";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
      });
      if (requestId !== ordersRequestId.current) return null;
      if (response && response.status === 1) {
        setAllOrders(response.data.branches || []);
        setTablePage(1);
        setGrandTotal(response.data.grand_total_cost);
        return response.data.branches;
      } else {
        showNotification(response && response.message, "Error");
        return null;
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return null;
      console.log(error);
      return null;
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  function mergeDuplicate(items) {
    if (!items?.length) return [];

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.item_id]) {
          acc[item.item_id] = { ...item };
        } else {
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
            item.unit_levels,
            item.quantity,
          );
          const existingQty = convertToLowestUnit(
            acc[item.item_id].unit_levels,
            acc[item.item_id].quantity,
          );
          const lowestUnit = item.unit_levels.at(-1).unit;

          const summedQuantity = [
            { unit: lowestUnit, value: Number(convertedQty + existingQty) },
          ];

          acc[item.item_id].quantity = GetUpdatedDelivered(
            summedQuantity,
            item.unit_levels,
          );
          acc[item.item_id].receiving_cost += Number(item.receiving_cost);
        }
        return acc;
      }, {}),
    );
  }

  const loadBranchwiseUsedItemsDetails = async (row) => {
    try {
      setSelectedRow(row);
      setSelectedBranch(row);
      setItemDetails([]);
      setItemModal(true);
      setIsLoadingBranchDetails(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_used_items_details";
      const response = await postSubmitForm(url, {
        branch_id: row._id,
        date_from: dateFrom,
        date_to: dateTo,
      });
      if (response && response.status === 1) {
        setFilterModalTotal(response.data.grand_total_cost || 0);
        setItemDetails(response.data?.items || []);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingBranchDetails(false);
    }
  };

  const [itemDetailsModal, setItemDetailsModal] = useState(false);
  const [itemDetailsLevel2, setItemDetailsLevel2] = useState([]);

  const loadItemDetails = async (item_id) => {
    try {
      setIsLoadingItemDetails(true);
      setItemDetailsLevel2([]);
      setItemDetailsModal(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_used_items_by_item";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = (response.data && response.data.details) || [];
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { receiving_cost = 0, unit_levels, quantity } = item || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0];
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        setItemDetailsLevel2(data);
        setFilterModalSubTotal(response.data.grand_total_cost || 0);
        setFilterModalTotalQty(displayQuantity);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingItemDetails(false);
    }
  };

  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [itemModal, setItemModal] = useState(false);
  const [filterModalTotal, setFilterModalTotal] = useState(0);

  function afterFilter(newResult, newFilters) {
    //console.log(newResult);
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0,
    );
    setFilterModalTotal(total.toFixed(2));
  }

  function afterFilterForDetails(newData, quantityField) {
    const data = newData;
    let totalCost = 0;
    let totalLowestUnitQty = 0;

    data.forEach((item) => {
      const { receiving_cost = 0, unit_levels, quantity } = item || {};

      totalCost += Number(receiving_cost || 0);

      if (unit_levels) {
        const quantityToBeDisplayed = quantity;

        if (quantityToBeDisplayed) {
          const convertedQty = convertToLowestUnit(
            unit_levels,
            quantityToBeDisplayed,
          );
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      }
    });
    let displayQuantity = "";
    const firstItemDetails = data[0];
    if (firstItemDetails?.unit_levels) {
      const { unit_levels } = firstItemDetails;
      const lowestUnit = unit_levels.at(-1).unit;

      const summedQuantity = [
        {
          unit: lowestUnit,
          value: totalLowestUnitQty,
        },
      ];

      displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
    }
    setFilterModalTotalQty(displayQuantity);
    setFilterModalSubTotal(totalCost.toFixed(2));
  }

  function afterSearch(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.item_cost),
      0,
    );
    const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
    setFilteredOrders((prevOrders) => {
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "item_cost",
      text: props.t("Item Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadBranchwiseUsedItemsDetails(row);
            }}
          >
            {row.item_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsItem = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadItemDetails(row.item_id);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Total Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    //       {
    //         dataField: "is_free",
    //         text: props.t("Free ?"),
    //         sort: false,
    //         headerStyle: (colum, colIndex) => {
    //           return { width: "6%" };
    //         },
    //         formatter: (cell) => (cell ? "Yes" : "No"),
    //         filter: selectFilter({
    //           options: [
    //             { value: true, label: "Yes" },
    //             { value: false, label: "No" },
    //           ],
    //           placeholder: "All",
    //         }),
    // },
    {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_po",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    // {
    //   dataField: "price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     if (row?.is_free) {
    //       return (row?.free_cost_price);
    //     } else {
    //       return (row?.price);
    //     }
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      // formatter: (cell, row) => {
      //   if (row?.is_free) {
      //     return (
      //       <div>
      //         <div>Projected: {row?.projected_cost}</div>
      //       </div>
      //     );
      //   } else {
      //     return `${row?.receiving_cost}`;
      //   }
      // },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "use_date",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.use_date).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
  ];

  const columnsItemDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row) => {
        let po_id = row?.po_id;
        return (
          <div>
            <div>{cell}</div>
            <small>
              {po_id ? (
                <a
                  href={"/purchase_order?po_id=" + po_id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {po_id}
                </a>
              ) : (
                <span className="text-muted fst-italic">
                  No PO - Manual Entry
                </span>
              )}
            </small>
          </div>
        );
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },

    {
      dataField: "name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.cost_price + "/" + row?..unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.is_free) {
          return row?.free_cost_price;
        } else {
          return row?.price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Cost (QR)"),
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (
            <div>
              <div>Projected: {row?.projected_cost}</div>
            </div>
          );
        } else {
          return row?.receiving_cost;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "use_date",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.use_date).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "branchwise_item_used_report_";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          ItemCost: v.item_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleDownloadModalData = async () => {
    const fileName = "branchwise_Used_item_detail_report_";
    const exportType = "xls";

    let data_to_export = itemDetails && itemDetails;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Item: v.name,
          Formula: v.unit_levels && exportFromula(v.unit_levels),
          "Total Quantity": ExportAvailableInCSVForReports(v.quantity),
          "Purchasing Unit": v.unit_for_po,
          "Total Cost": v.receiving_cost,
        });
      });
      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branchwise Used Item Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branchwise Used Item Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"  "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Used Item Cost Report")}{" "}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                delay={500}
                                onSearch={(searchText) => {
                                  if (!searchText || searchText.trim() === "") {
                                    toolkitProps.searchProps.onSearch(
                                      searchText,
                                    );
                                    afterSearch(toolkitProps.baseProps.data);
                                    return;
                                  }
                                  if (searchText?.length <= 3) return;
                                  const searchResult =
                                    toolkitProps.baseProps.data?.filter(
                                      (row) => {
                                        const matchesSearch = (value) => {
                                          if (
                                            value === null ||
                                            value === undefined
                                          )
                                            return false;
                                          if (typeof value === "object") {
                                            return Object.values(value).some(
                                              (v) => matchesSearch(v),
                                            );
                                          }
                                          return String(value)
                                            .toLowerCase()
                                            .includes(searchText.toLowerCase());
                                        };
                                        return Object.values(row).some(
                                          matchesSearch,
                                        );
                                      },
                                    );

                                  toolkitProps.searchProps.onSearch(searchText);
                                  afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4} className="text-right">
                              <h5>
                                {" "}
                                Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Item breakup modal */}
          <Modal
            size="xl"
            isOpen={itemModal}
            toggle={() => setItemModal(!itemModal)}
          >
            <ModalHeader toggle={() => setItemModal(!itemModal)}>
              <Button
                type="submit"
                className="btn btn-sm btn-secondary"
                onClick={handleDownloadModalData}
              >
                <i className="mdi mdi-file-export"></i> {props.t("Export CSV")}
              </Button>
              <Link
                to="#"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  printDiv("printDiv1");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row id="printDiv1">
                        <Col lg={12}>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("Item Details")}
                          </CardTitle>
                          <h5>
                            Branch : {selectedRow.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="item_id"
                            data={itemDetails && itemDetails}
                            columns={columnsItem}
                            striped
                            hover
                            condensed
                            filter={filterFactory({ afterFilter })}
                            noDataIndication={
                              isLoadingBranchDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemDetailsModal}
            toggle={() => setItemDetailsModal(!itemDetailsModal)}
          >
            <ModalHeader toggle={() => setItemDetailsModal(!itemDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitem">
                <Col lg={12}>
                  <CardTitle className="text-center">
                    {props.t("Branchwise Used Item Cost Report")}
                  </CardTitle>

                  <CardTitle className="text-center">
                    {props.t("Item Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Used Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div
                            className="mb-1"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "0px",
                            }}
                          >
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch?.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={itemDetailsLevel2 && itemDetailsLevel2}
                            columns={columnsItemDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "quantity",
                                    "",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            noDataIndication={
                              isLoadingItemDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {},
  )(withNamespaces()(BranchwiseItemUsedInventoriesCostReport)),
);
